import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import thunk from "redux-thunk";
import {Provider} from "react-redux";
import * as serviceWorker from './serviceWorker';
import rootReducer, {RootState} from "./reducers/index";
import {applyMiddleware, createStore, Store} from "redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import 'react-quill/dist/quill.snow.css'; // ES6
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


export const store = createStore(rootReducer(), applyMiddleware(thunk)) as Store<RootState>;

ReactDOM.render(
  <React.StrictMode>
      <Provider store={store}>
          <Router>
              <Route path="/" component={App} />
          </Router>
      </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
